<!--
  收款码
  lovi 2020-06-17
-->
<template>
  <div class="w100">
    <van-nav-bar
      class="head-blue"
      :title="$t('home.receiveCode')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper">
      <div class="info-box">
        <h3>{{ $t("home.eepayScanPayMe") }}</h3>
        <div id="qrCode" ref="qrCode"></div>
        <div class="info" v-if="money">
          <h4>{{ money }}P</h4>
          <p v-if="remark != ''" class="remark">{{ remark }}</p>
        </div>
        <div class="operation text-blue">
          <span v-if="money" @click="clearMoney">{{
            $t("home.removeAmount")
          }}</span>
          <span v-else @click="moneyFlag = true">{{
            $t("home.setAmount")
          }}</span>
          <span @click="savePicture(pic)">{{ $t("home.saveImage") }}</span>
        </div>
        <van-cell :title="$t('home.receiveRecords')" icon="shoukuan" is-link />
      </div>
    </div>

    <transition name="slide">
      <set-money
        v-if="moneyFlag"
        :moneyFlag.sync="moneyFlag"
        @getMoneyInfo="getMoneyInfo"
      />
    </transition>
  </div>
</template>

<script>
const icon_hangkong = require("@/assets/images/home/icon/icon_hangkong@2x.png");
import QRCode from "qrcodejs2";
import SetMoney from "./money";
export default {
  name: "collectionCode",
  meta: {
    service: false // 客服
  },
  components: {
    SetMoney
  },
  data() {
    return {
      moneyFlag: false, // 设置金额Flag
      money: 0, // 收款金额
      remark: "", // 收款理由
      pic: ""
    };
  },
  created() {
    this.pic = icon_hangkong;
    this._getQrCodeData();
  },
  mounted() {},
  computed: {},
  methods: {
    clearMoney() {
      // 清除金额
      this.money = 0;
      this.remark = "";
      this._getQrCodeData();
    },
    getMoneyInfo(data) {
      // 获取金额信息
      console.log("getMoneyInfo", data);
      this.money = data.money;
      this.remark = data.remark;
      this._getQrCodeData();
    },
    _getQrCodeData() {
      let vm = this;
      let params = {};
      params.type = 2;
      params.money = vm.money;
      params.remarks = vm.remark;
      vm.$post("/app/recharge/qrCode", params, { loading: true }).then(res => {
        console.log("qrCode", res);
        if (vm.$refs.qrCode) {
          vm.$refs.qrCode.innerHTML = "";
        }
        vm._getQrcode(res.QRCode);
        vm.QrCodeDecrypt(res);
      });
    },
    QrCodeDecrypt(data) {
      this.$post(
        "/app/recharge/QrCodeDecrypt",
        { qrcode: data.QRCode },
        {
          loading: true
        }
      ).then(res => {
        console.log("QrCodeDecrypt", res);
      });
    },
    _getQrcode(str) {
      // 生成二维码
      new QRCode(this.$refs.qrCode, {
        width: 200,
        height: 200,
        text: str // 内容
      });
    },
    savePicture(Url) {
      var blob = new Blob([""], { type: "application/octet-stream" });
      var url = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = Url;
      a.download = Url.replace(/(.*\/)*([^.]+.*)/gi, "$2").split("?")[0];
      var e = document.createEvent("MouseEvents");
      e.initMouseEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      a.dispatchEvent(e);
      URL.revokeObjectURL(url);
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.scroll-wrapper {
  background: #1e39a1;
}
.info-box {
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 320px;
  padding: 15px 15px 0px 15px;
  line-height: 1.2;
  background: #fff;
  border-radius: 8px;
  h3 {
    font-size: 14px;
    font-weight: 400;
  }
  #qrCode {
    margin: 15px 0;
  }
  .info {
    margin-bottom: 15px;
    text-align: center;
    h4 {
      font-size: 18px;
      font-weight: 400;
    }
    .remark {
      margin-top: 2px;
    }
  }
  .operation {
    font-size: 14px;
    line-height: 1;
    span {
      position: relative;
      &:first-child {
        padding-right: 20px;
        margin-right: 20px;
        border-right: 1px solid #dcdcdc;
      }
    }
  }
  /deep/.van-cell {
    margin-top: 15px;
    padding: 8px 0;
    border-top: 1.1px solid #dcdcdc;
    .van-icon-shoukuan {
      width: 24px;
      height: 24px;
      background-image: url("@{images}home/icon_shoukuan_icon@2x.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: 20px 20px;
    }
    .van-cell__title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 24px;
      line-height: 1;
      font-size: 14px;
    }
  }
}
</style>
